import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Card, CardText } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

import ComponentCard from '../../../components/ComponentCard';

const MasterbrandVendor = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const fetchTabData = async (tab) => {
    const vendorName = user?.name;
    setLoading(true);
    setError(null);
    let api = `https://amaapi.outdoorooh.com/api/masterbrand-site-vendor-project/${vendorName}`;

    if (tab === '2') {
      api = `https://amaapi.outdoorooh.com/api/masterbrand-site-vendor-approved-sites/${vendorName}`;
    } else if (tab === '3') {
      api = `https://amaapi.outdoorooh.com/api/masterbrand-site-vendor-pending-sites/${vendorName}`;
    } else if (tab === '4') {
      api = `https://amaapi.outdoorooh.com/api/masterbrand-site-vendor-rejected-sites/${vendorName}`;
    } else if (tab === '5') {
      api = `https://amaapi.outdoorooh.com/api/masterbrand-site-asm-rejected-site-for-vendor/${vendorName}`;
    }

    try {
      const response = await fetch(api);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setData(result.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      fetchTabData(tab);
    }
  };
  const filteredData = data.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.site_name?.toLowerCase().includes(term) ||
      item.code?.toLowerCase().includes(term) ||
      item.state?.toLowerCase().includes(term) ||
      item.zone?.toLowerCase().includes(term)
    );
  });
  useEffect(() => {
    fetchTabData(activeTab);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  const baseUrl = 'https://amaapi.outdoorooh.com/';

  // ✅ Export function
  const exportToExcel = () => {
    if (!filteredData.length) {
      alert('No data available to export');
      return;
    }

    // Prepare headers
    const headers = [
      'Site Name',
      'Zone',
      'State',
      'Area',
      'Code',
      'Vendor Name',
      'Lat',
      'Long',
      'Length',
      'Width',
      'Availability',
      'Media Type',
      'Remarks',
      'Deviation',
      'Total Sqft.',
      'ASM Name',
      'Type',
      'Recce Person Name',
      'Image ',
      'Image 1',
      'Image 2',
      'Image 3',
      'Image 4',
      'Recce Person Image',

    ];

    // Prepare rows
    const rows = filteredData.map((item) => [
      item.site_name,
      item.zone,
      item.state,
      item.area,
      item.code,
      item.vendor_name,
      item.lat,
      item.long,
      item.length,
      item.width,
      item.availability,
      item.media_type,
      item.remarks,
      item.address,
      item.total,
      item.asm_name,
      item.type,
      item.racce_person_name,
      item.image ? { f: `HYPERLINK("${baseUrl}${item.image}", "View Image")` } : '',
      item.image1 ? { f: `HYPERLINK("${baseUrl}${item.image1}", "View Image")` } : '',
      item.image2 ? { f: `HYPERLINK("${baseUrl}${item.image2}", "View Image")` } : '',
      item.image3 ? { f: `HYPERLINK("${baseUrl}${item.image3}", "View Image")` } : '',
      item.image4 ? { f: `HYPERLINK("${baseUrl}${item.image4}", "View Image")` } : '',
      item.racce_person_image ? { f: `HYPERLINK("${baseUrl}${item.image1}", "View Image")` } : '',
    ]);

    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Vendor Data');
    XLSX.writeFile(wb, `Vendor_Data_${user?.name || 'Export'}.xlsx`);
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <button type="button" onClick={exportToExcel} className="btn btn-primary mb-3 me-2">
            Export to Excel
          </button>
        </div>
        <input
          type="text"
          className="form-control p-2"
          placeholder="Search here"
          style={{ maxWidth: '300px' }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <ComponentCard title="Airtel Postpaid  OOH Campaign Vendor Projects">
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => toggle('1')}>
              All
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => toggle('2')}>
              Approved
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => toggle('3')}>
              Pending
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '4' ? 'active' : ''} onClick={() => toggle('4')}>
              Rejected
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab === '5' ? 'active' : ''} onClick={() => toggle('5')}>
              Rejected By State Head
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent className="p-4" activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              {filteredData.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <Link to={`/airtel-masterbrand-project-detail/${item.id}`}>
                              <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                                <img
                                  src={`https://amaapi.outdoorooh.com/${img}`}
                                  loading="lazy"
                                  className="d-block w-100"
                                  style={{ height: '200px' }}
                                  alt={item.site_name}
                                />
                              </div>
                            </Link>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                        (img) => img,
                      ).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-masterbrand-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://amaapi.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                        (img) => img,
                      ).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-masterbrand-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[
                          item.new_image,
                          item.new_image1,
                          item.new_image2,
                          item.new_image3,
                          item.new_image4,
                        ]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://amaapi.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[
                        item.new_image,
                        item.new_image1,
                        item.new_image2,
                        item.new_image3,
                        item.new_image4,
                      ].filter((img) => img).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-masterbrand-vendor-pending/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://amaapi.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                        (img) => img,
                      ).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-masterbrand-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>

          <TabPane tabId="5">
            <Row>
              {data.map((item) => (
                <Col md="6" lg="4" key={item.id}>
                  <Card body>
                    <div
                      id={`carousel-${item.id}`}
                      className="carousel slide"
                      data-bs-touch="false"
                    >
                      <div className="carousel-inner">
                        {[item.image, item.image1, item.image2, item.image3, item.image4]
                          .filter((img) => img) // Remove null or undefined images
                          .map((img, index) => (
                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                              <img
                                src={`https://amaapi.outdoorooh.com/${img}`}
                                loading="lazy"
                                className="d-block w-100"
                                style={{ height: '200px' }}
                                alt={item.site_name}
                              />
                            </div>
                          ))}
                      </div>

                      {/* Show controls only if there's more than one image */}
                      {[item.image, item.image1, item.image2, item.image3, item.image4].filter(
                        (img) => img,
                      ).length > 1 && (
                        <>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#carousel-${item.id}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </>
                      )}
                    </div>

                    <Link
                      to={`/airtel-masterbrand-project-detail/${item.id}`}
                      style={{ color: '#333', textDecoration: 'none', marginTop: '10px' }}
                    >
                      <CardText>{item.code}</CardText>
                      <CardText>{item.site_name}</CardText>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </TabPane>
        </TabContent>
      </ComponentCard>
    </>
  );
};

export default MasterbrandVendor;
